import { render, staticRenderFns } from "./GetSecureDocuments.vue?vue&type=template&id=0d264884&scoped=true&"
import script from "./GetSecureDocuments.vue?vue&type=script&lang=js&"
export * from "./GetSecureDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d264884",
  null
  
)

export default component.exports